/** @var BryanAnthonysWishlist */

BryanAnthonysWishlist.Wishlist = class {
    constructor(data) {
        this.data = data;
    }

    getId() {
        return this.data && this.data.wishlist_id ? this.data.wishlist_id : null;
    }

    getHandle() {
        return this.data && this.data.handle ? this.data.handle : null;
    }

    getSecret() {
        if (BryanAnthonysWishlist.customerId) {
            return BryanAnthonysWishlist.customerSecret;
        }

        return this.data && this.data.secret ? this.data.secret : null;
    }

    getTitle() {
        return this.data && this.data.title
            ? BryanAnthonys.escapeHtml(this.data.title)
            : '';
    }

    getProducts() {
        return this.data && this.data.products && Array.isArray(this.data.products)
            ? this.data.products
            : [];
    }
};

BryanAnthonysWishlist.getCachedWishlists = function () {
    let storedWishlists = localStorage.getItem(BryanAnthonysWishlist.storageKey);
    if (storedWishlists) {
        try {
            storedWishlists = JSON.parse(storedWishlists);
        } catch (e) {
            storedWishlists = {wishlists: {}};
        }
    }
    if (!storedWishlists || !storedWishlists.wishlists) {
        storedWishlists = {wishlists: {}};
    }

    return storedWishlists;
};

BryanAnthonysWishlist.clearWishlistCache = function () {
    localStorage.removeItem(BryanAnthonysWishlist.storageKey);
    localStorage.removeItem(BryanAnthonysWishlist.reconciliationStorageKey);
};

/**
 * @returns {BryanAnthonysWishlist.Wishlist}
 */
BryanAnthonysWishlist.getCachedWishlist = function (key = 'default') {
    const storedWishlists = BryanAnthonysWishlist.getCachedWishlists();

    return new BryanAnthonysWishlist.Wishlist(storedWishlists.wishlists[key]);
};

BryanAnthonysWishlist.cacheWishlist = function (wishlist, key = 'default') {
    let storedWishlists = BryanAnthonysWishlist.getCachedWishlists();

    storedWishlists.wishlists[key] = wishlist;

    localStorage.setItem(BryanAnthonysWishlist.storageKey, JSON.stringify(storedWishlists));

    document.dispatchEvent(new CustomEvent('wishlistChanged', {
        detail: {
            wishlistKey: key,
            wishlist
        }
    }));
};

BryanAnthonysWishlist.addToWishlist = function (variantId, price = null, wishlistKey = 'default') {
    const wishlist = BryanAnthonysWishlist.getCachedWishlist(wishlistKey);
    const url = `${BryanAnthonysWishlist.baseUrl}/add-to-wishlist`;

    const payload = {
        variant_id: variantId,
    };
    if (price) {
        payload.price = price;
    }
    if (wishlist.getId()) {
        payload.wishlist_id = wishlist.getId();
    }
    if (wishlist.getSecret()) {
        payload.wishlist_secret = wishlist.getSecret();
    }
    if (BryanAnthonysWishlist.customerId) {
        payload.customer_id = BryanAnthonysWishlist.customerId;
    }

    return new Promise(function (resolve, reject) {
        fetch(url, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }),
            body: JSON.stringify(payload)
        })
            .then(BryanAnthonys.decodeJsonResponse)
            .then(response => {
                BryanAnthonysWishlist.cacheWishlist(response, wishlistKey);
                resolve(response);
            })
            .catch(exception => {
                if (exception instanceof ResponseException && exception.response.status === 409) {
                    BryanAnthonysWishlist.clearWishlistCache();
                }
                reject(exception);
            });
    });
};

BryanAnthonysWishlist.removeFromWishlist = function (variantId, wishlistKey = 'default') {
    const wishlist = BryanAnthonysWishlist.getCachedWishlist(wishlistKey);
    const url = `${BryanAnthonysWishlist.baseUrl}/remove-from-wishlist`;

    const payload = {
        variant_id: variantId,
        wishlist_id: wishlist.getId(),
        wishlist_secret: wishlist.getSecret()
    };

    return new Promise(function (resolve, reject) {
        fetch(url, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }),
            body: JSON.stringify(payload)
        })
            .then(BryanAnthonys.decodeJsonResponse)
            .then(response => {
                BryanAnthonysWishlist.cacheWishlist(response, wishlistKey);
                resolve(response);
            })
            .catch(reject);
    });
};

BryanAnthonysWishlist.reconcileCustomerWishlists = function () {
    const url = `${BryanAnthonysWishlist.baseUrl}/reconcile-customer-wishlists`;

    const payload = {
        customer_id: BryanAnthonysWishlist.customerId,
        customer_secret: BryanAnthonysWishlist.customerSecret
    };

    const defaultWishlist = BryanAnthonysWishlist.getCachedWishlist();
    if (defaultWishlist.getId()) {
        payload.wishlist_id = defaultWishlist.getId();
    }

    return new Promise(function (resolve) {
        fetch(url, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }),
            body: JSON.stringify(payload)
        })
            .then(BryanAnthonys.decodeJsonResponse)
            .then(wishlists => {
                if (wishlists.length) {
                    localStorage.removeItem(BryanAnthonysWishlist.storageKey);
                }
                wishlists.forEach(wishlist => {
                    const key = wishlist.is_default ? 'default' : (wishlist.handle || `wish-${Math.random()}`);
                    BryanAnthonysWishlist.cacheWishlist(wishlist, key);
                });

                document.dispatchEvent(new CustomEvent('wishlistsReconciled', {detail: {wishlists}}));
            })
            .catch(exception => {
                console.error(exception);
            })
            .finally(() => {
                localStorage.setItem(BryanAnthonysWishlist.reconciliationStorageKey, 'true');
                resolve();
            });
    });
};

class WishlistButton extends HTMLElement {
    constructor() {
        super();

        this.dataset.wishlist = 'default';
    }

    connectedCallback() {
        this.toggleState();
        this.addEventListener('click', event => {
            const isIntendedTarget = event.target.nodeName === 'BUTTON' || event.target.closest('button');
            if (!isIntendedTarget || this.dataset.loading) {
                return;
            }

            this.classList.add('wishlist-button--animated');
            this.dataset.loading = 'true';

            if (this.classList.contains('wishlist-button--active')) {
                BryanAnthonysWishlist.removeFromWishlist(this.dataset.variantInWishlist, this.dataset.wishlist)
                    .then(() => {
                        this.removeAttribute('data-loading');
                        this.toggleState();
                        document.dispatchEvent(new CustomEvent('itemRemovedFromWishlist', {
                            detail: {
                                productTitle: this.dataset.productTitle,
                                productId: this.dataset.product,
                                variantId: this.dataset.variant,
                            }
                        }));
                    })
                    .catch(error => {
                        console.error(error);
                        BryanAnthonys.showToast(BryanAnthonys.strings.general.genericAjaxError, 'error');
                    })
                    .finally(() => this.removeAttribute('data-loading'));
            } else {
                BryanAnthonysWishlist.addToWishlist(
                    this.dataset.variant,
                    this.extractProductPrice(),
                    this.dataset.wishlist
                ).then(() => {
                    this.toggleState();
                    document.dispatchEvent(new CustomEvent('itemAddedToWishlist', {
                        detail: {
                            productTitle: this.dataset.productTitle,
                            productId: this.dataset.product,
                            variantId: this.dataset.variant,
                        }
                    }));
                }).catch(error => {
                    console.error(error);
                    BryanAnthonys.showToast(BryanAnthonys.strings.general.genericAjaxError, 'error');
                }).finally(() => this.removeAttribute('data-loading'));
            }
        });
    }

    toggleState() {
        const wishlist = BryanAnthonysWishlist.getCachedWishlist(this.dataset.wishlist);
        const inWishlist = wishlist.getProducts().find(product => product.product_id === parseInt(this.dataset.product));
        const button = this.querySelector('button');
        if (inWishlist) {
            this.classList.add('wishlist-button--active');
            this.dataset.variantInWishlist = inWishlist.variant_id;
            button.setAttribute('aria-label', button.dataset.removeLabel);
        } else {
            this.classList.remove('wishlist-button--active');
            this.removeAttribute('data-variant-in-wishlist');
            button.setAttribute('aria-label', button.dataset.addLabel);
        }
    }

    extractProductPrice() {
        const productElement = this.closest('product-card') || this.closest('product-section');
        if (!productElement) {
            return null;
        }

        const price = productElement.querySelector('[data-product-sale-price-cents]');

        return price ? parseInt(price.dataset.productSalePriceCents) : null;
    }
}

customElements.define('wishlist-button', WishlistButton);

class WishlistOpener extends HTMLElement {
    constructor() {
        super();
        this.dataset.wishlist = 'default';

        this.addEventListener('click', () => {
            window.location.href = BryanAnthonysWishlist.displayPageUrl;
        });

        document.addEventListener('wishlistChanged', event => {
            if (event.detail.wishlistKey === this.dataset.wishlist) {
                this.updateCount();
            }
        });
    }

    connectedCallback() {
        setTimeout(() => this.updateCount());
    }

    updateCount() {
        this.querySelectorAll('[data-wishlist-count]').forEach(count => count.remove());
        const wishlist = BryanAnthonysWishlist.getCachedWishlist(this.dataset.wishlist);

        const target = this.querySelector('button') || this.querySelector('a') || this;
        target.insertAdjacentHTML('beforeend', `
            <span data-wishlist-count class="wishlist-count" aria-hidden="true"></span>
        `);
        target.querySelector('[data-wishlist-count]').textContent = wishlist.getProducts().length;
    }
}

customElements.define('wishlist-opener', WishlistOpener);

class WishlistSection extends HTMLElement {
    connectedCallback() {
        BryanAnthonys.loadScript('storefront-catalog');
        BryanAnthonys.loadScript('wishlist-page');
    }
}

customElements.define('wishlist-section', WishlistSection);

// Reconcile wishlists right after login
document.addEventListener('DOMContentLoaded', () => {
    if (BryanAnthonysWishlist.customerId) {
        const wishlistsReconciled = localStorage.getItem(BryanAnthonysWishlist.reconciliationStorageKey);
        const onWishlistPage = window.location.href.includes(BryanAnthonysWishlist.displayPageUrl);

        if (wishlistsReconciled !== 'true' && !onWishlistPage) {
            BryanAnthonysWishlist.reconcileCustomerWishlists();
        }
    } else {
        localStorage.setItem(BryanAnthonysWishlist.reconciliationStorageKey, 'false');
    }
});
